import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import {
	IPropsGetSendWhatsupMessagev2,
	IResponseGetSendWhatsupMessagev2,
} from "./types"
import { sendWhatssAppMessageUrlV2 } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getSendWhatsupMessagev2(
	apiPrivate: AxiosInstance,
	{ ...rest }: IPropsGetSendWhatsupMessagev2
) {
	try {
		const response: AxiosResponse<IResponseGetSendWhatsupMessagev2> =
			await apiPrivate.get(`${sendWhatssAppMessageUrlV2}`,{
				params:rest
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetSendWhatsupMessagev2(
	data: IPropsGetSendWhatsupMessagev2,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetSendWhatsupMessagev2,
					unknown,
					IResponseGetSendWhatsupMessagev2
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETSENDWHATSUPMESSAGE, ...Object.values(data)],
		queryFn: () => getSendWhatsupMessagev2(apiPrivate, data),
		...options,
	})
}
